export const LOCAL_STORAGE_RESERVATION_REDIRECT = 'reservationRedirect';
export const LOCAL_STORAGE_RESERVATION = 'reservation';
export const LOCAL_STORAGE_RESERVATION_DATA = 'reservationData';
export const LOCAL_STORAGE_SERVICE_ENTRY = 'serviceEntry';
